import { createSlice } from '@reduxjs/toolkit'
import { isEmpty } from '../../../../../utils/fns'

const isCalculationAction = (action) => action.type.toLowerCase().endsWith('calculation')

export const formSlice = createSlice({
  name: 'form',
  initialState: {
    errors: {},
    isValid: true,
  },
  reducers: {
    setFieldError: (state, action) => {
      state.errors[action.payload.name] = action.payload.message
    },
    removeFieldError: (state, action) => {
      delete state.errors[action.payload]
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isCalculationAction, (state) => {
      state.isValid = isEmpty(Object.values(state.errors))
    })
  },
})

export const formActions = formSlice.actions
